<template>
  <button class="audio-timecode-list-btn">
    <ListIcon class="audio-timecode-list-btn__icon" />
    <p class="audio-timecode-list-btn__txt">{{ text }}</p>
  </button>
</template>

<script setup>
  import ListIcon from '../../svg/ListIcon.vue';
  //-----------------------------
  const props = defineProps({
    //Текст кнопки
    text: { type: String }
  });
</script>

<style scoped lang="scss">
  @import './styles.scss';
</style>